import { backendUrl } from './variables';

/**
 * Resolve platform admin access from server allowlist (admin_emails.php / admin_allowlist.php).
 * Returns a normalized adminData object, or null if not allowlisted.
 */
export async function fetchAllowlistedAdmin(email) {
  const normalized = String(email || '').trim().toLowerCase();
  if (!normalized) return null;

  try {
    const response = await fetch(`${backendUrl}/admin_emails.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: normalized }),
    });
    if (!response.ok) return null;

    const data = await response.json();
    const allowed =
      data?.isAdmin === true ||
      (Array.isArray(data?.emails) &&
        data.emails.map((e) => String(e).toLowerCase()).includes(normalized));

    if (!allowed) return null;

    return {
      email: normalized,
      role: 'allowlisted_admin',
      permissions: {
        dashboard: true,
        users: true,
        applications: true,
        analytics: true,
        notif: true,
        subadmins: true,
      },
    };
  } catch (error) {
    console.error('fetchAllowlistedAdmin:', error);
    return null;
  }
}
